import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ToU from "../components/termofuse"

const ToUPage = () => (
  <Layout>
    <SEO title="Term of Use" />
    <ToU />
  </Layout>
)

export default ToUPage
